import { inject, Injectable } from "@angular/core";
import { InterpolatableTranslationObject, InterpolationParameters, StrictTranslation, TranslateService } from "@ngx-translate/core";
import { catchError, map, mergeMap, Observable, of, startWith } from "rxjs";
import { AppLocaleService } from "../services/app-locale.service";

@Injectable()
export class AppTranslateService extends TranslateService {
  private readonly locale = inject(AppLocaleService);

  public override use(lang: string): Observable<InterpolatableTranslationObject> {
    return this.locale.loadLocaleData(lang).pipe(
      catchError(() => of(<void>undefined)),
      mergeMap(() => super.use(lang))
    );
  }

  public override instant(key: string | Array<string>, interpolateParams?: InterpolationParameters): StrictTranslation {
    if (!key) {
      return "";
    }
    return super.instant(key, interpolateParams);
  }

  public override get(key: string | Array<string>, interpolateParams?: InterpolationParameters): Observable<StrictTranslation> {
    if (!key) {
      return of("");
    }
    return super.get(key, interpolateParams);
  }

  public override getStreamOnTranslationChange(
    key: string | Array<string>,
    interpolateParams?: InterpolationParameters
  ): Observable<StrictTranslation> {
    if (!key) {
      return super.onTranslationChange.pipe(
        map(() => ""),
        startWith("")
      );
    }
    return super.getStreamOnTranslationChange(key, interpolateParams);
  }

  public override stream(key: string | Array<string>, interpolateParams?: InterpolationParameters): Observable<StrictTranslation> {
    if (!key) {
      return super.onLangChange.pipe(
        map(() => ""),
        startWith("")
      );
    }
    return super.stream(key, interpolateParams);
  }

  public override getParsedResult(
    key: string | string[],
    interpolateParams?: InterpolationParameters
  ): StrictTranslation | Observable<StrictTranslation> {
    if (!key) {
      return "";
    }
    return super.getParsedResult(key, interpolateParams);
  }
}
